<template>
  <DashboardTemplate :navMenu="true">
    <div class="box-overflow normal">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">จัดการรายชื่อผู้เรียน</h2>
      </div>
      <div class="flex-display js-between">
          <div>
            <div v-if="showSearch" class="text-left pd-b-3">
              <p class="mg-y-less">
                <span class="text-weight-600">ค้นหา</span> “{{ searchText }}”
              </p>
            </div>
          </div>

          <div class="pd-b-3 flex-display js-end">
            <el-form @submit.prevent.native @keyup.enter.native="search">
              <el-input
                placeholder="ค้นหารายชื่อผู้เรียน"
                prefix-icon="el-icon-search"
                class="search-input"
                @blur="showInputSearch = false,!searchText && showSearch?search():null"
                @keyup.enter.native="search"
                @clear="searchText = '',search()"
                :class="{ show: showInputSearch }"
                ref="search"
                clearable
                v-model="searchText"
              ></el-input>

              <el-button
                v-if="!showInputSearch"
                @click="openSearchInput"
                icon="el-icon-search"
                round
                class="pd-x-2 primary border-color-primary"
                >ค้นหา</el-button
              >
            </el-form>
            <el-button @click="csvExport" type="primary" class="mg-l-4" round>ดาวน์โหลดข้อมูล</el-button>
          </div>
      </div>

      <div>
        <el-table
          v-loading="loading"
          v-if="showTable"
          :data="nameList"
          border
          :header-row-style="tableHeaderStyle"
          :header-cell-style="tableHeaderStyle"
          empty-text="ไม่พบข้อมูล"
        >
          <el-table-column
            type="index"
            label="ลำดับ"
            header-align="center"
            align="center"
            sortable
            width="80"
            :index="(index) => indexMethod(index, page, pageSize)"
          ></el-table-column>
          <el-table-column
            prop="nameTH"
            label="ชื่อ"
            header-align="center"
            sortable
            :width="
              widthMax < 767.98
                ? '140'
                : widthMax < 991
                ? '130'
                : widthMax < 1199.98
                ? '130'
                : ''
            "
          ></el-table-column>
          <el-table-column
            prop="surnameTH"
            label="นามสกุล"
            header-align="center"
            sortable
            :width="
              widthMax < 767.98
                ? '140'
                : widthMax < 991
                ? '130'
                : widthMax < 1199.98
                ? '130'
                : ''
            "
          ></el-table-column>
          <el-table-column
            prop="company"
            label="ชื่อบริษัท"
            header-align="center"
            sortable
            :width="
              widthMax < 767.98
                ? '140'
                : widthMax < 991
                ? '130'
                : widthMax < 1199.98
                ? '130'
                : ''
            "
          ></el-table-column>
          <el-table-column
            prop="mobilephone"
            label="เบอร์โทรศัพท์"
            width="115"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="register"
            label="หลักสูตรที่ขออนุมัติ"
            width="80"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="approve"
            label="หลักสูตรที่อนุมัติแล้ว"
            width="80"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="studying"
            label="หลักสูตรที่กำลังเรียน"
            width="80"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="complete"
            label="หลักสูตรที่เรียนจบ"
            width="80"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="updatedAt"
            label="อัปเดทล่าสุดเมื่อ"
            :width="
              widthMax < 767.98
                ? '160'
                : widthMax < 991
                ? '160'
                : widthMax < 1199
                ? '160'
                : widthMax > 1200
                ? '250'
                : ''
            "
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.updatedAt | dateTimeTh
            }}</template>
          </el-table-column>

          <el-table-column
            label
            width="100"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="flex-display ai-center js-center">
                <div class="box-action">
                  <div
                    @click="
                      $router.push(
                        `/name/list/profile?edit=false&userId=${scope.row._id}`
                      )
                    "
                    class="circle-action color-bg-secondary"
                  >
                    <i class="fas fa-eye"></i>
                  </div>
                </div>
                <el-dropdown trigger="click" >
                  <span class="el-dropdown-link">
                    <div class="box-action">
                      <div class="circle-action color-bg-secondary">
                        <i class="fas fa-pen"></i>
                      </div>
                    </div>
                  </span>
                  <el-dropdown-menu slot="dropdown" class="not-scroll">
                    <el-dropdown-item
                      ><div
                        @click="
                          $router.push(
                            `/name/list/profile?edit=true&userId=${scope.row._id}`
                          )
                        "
                      >
                        แก้ไขข้อมูลส่วนตัว
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div
                        @click="
                          $router.push(
                            `/name/list/activity?userId=${scope.row._id}`
                          )
                        "
                      >
                        แก้ไขหลักสูตร
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div
                        @click="
                          $router.push(
                            `/name/list/course?userId=${scope.row._id}`
                          )
                        "
                      >
                        อนุมัติหลักสูตร
                      </div></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <div class="box-action">
                  <el-popconfirm
                    confirmButtonText="ใช่"
                    cancelButtonText="ไม่"
                    icon="el-icon-info"
                    iconColor="red"
                    title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                    @onConfirm="delStudent(scope.row._id)"
                  >
                    <div
                      slot="reference"
                      class="circle-action color-bg-danger-lighter"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </div>
                  </el-popconfirm>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="totalStudent > pageSize" class="pd-y-3">
        <el-pagination
          @current-change="changePage"
          background
          layout="prev, pager, next"
          :total="totalStudent"
          :page-size="pageSize"
          :current-page="page"
        >
        </el-pagination>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import { tableHeaderStyle } from "@/service/table";
import { HTTP } from "@/service/axios.js";

export default {
  routeParams: {
    type: Object,
    default: null,
  },
  components: {
    DashboardTemplate,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    nameList() {
      return this.nameListConst.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      );
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      nameListConst: [],
      searchText: "",
      page: 1,
      pageSize: 10,
      totalStudent: 0,
      showInputSearch: false,
      loading: true,
      userId: "",
      prefix: "",
      nameTh: "",
      showSearch:false,
    };
  },
  mounted() {
    this.setParams();
    this.fetchStudents();
    this.fetchCourseList();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    csvExport() {
      let columnsTemplate =[
        'ลำดับ',
        'ชื่อ',
        'นามสกุล',
        'ชื่อบริษัท',
        'เบอร์โทรศัพท์',
        'หลักสูตรที่ขออนุมัติ',
        'หลักสูตรที่อนุมัติแล้ว',
        'หลักสูตรที่กำลังเรียน',
        'หลักสูตรที่เรียนจบ',
        'อัปเดทล่าสุดเมื่อ'
      ]

        let title = []
        for (let index = 0; index < columnsTemplate.length; index++) {
          title.push(columnsTemplate[index])   
        }

        let data = []
        for (let index = 0; index < this.nameListConst.length; index++) {
          let obj ={
            index:index+1,
            nameTH:this.nameListConst[index].nameTH,
            surnameTH:this.nameListConst[index].surnameTH,
            company:this.nameListConst[index].company,
            mobilephone:this.nameListConst[index].mobilephone,
            register:this.nameListConst[index].register,
            approve:this.nameListConst[index].approve,
            studying:this.nameListConst[index].studying,
            complete:this.nameListConst[index].complete,
            updatedAt:this.$options.filters.dateTimeTh(this.nameListConst[index].updatedAt)
          }
          data.push(obj)   
        }
        let csvContent = "";
        csvContent += [
            title.join(","),
            ...data.map(item => Object.values(item).join(","))
        ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

          
        var link = window.document.createElement("a");
        link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
        
        let dataFile = "รายชื่อผู้เรียน_"+new Date().getDate()+'-'+(new Date().getMonth() + 1)+'-'+new Date().getFullYear()
        link.setAttribute("download", dataFile+'.csv');
        link.click();
    },
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.edit != "undefined") {
          this.userId = this.routeParams.userId;
        }
      }
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {

        this.$refs.search.focus();
      }, 500);
    },
    changePage(page) {
      this.page = page;
    },
    fetchStudents() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(
        `students/0/0/${this.searchText != "" ? this.searchText : "all"}`
      )
        .then((res) => {

          if (res.data.success) {
            this.nameListConst = res.data.obj;
            this.totalStudent = res.data.count;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudents error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    search() {
      this.loading = true;
      this.page = 1
      this.fetchStudents();
      if (this.searchText != "") {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    },
    delStudent(id) {
      this.loading = true;
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`delete/student/${id}`)
        .then((res) => {
          if (res.data.success) {
            this.fetchStudents()
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delStudent error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
